export function createPageItems(pageCount, activePage, segmentCount, indicators) {
  // If size of segments is larger than total count of pages, return full array
  if (pageCount <= segmentCount || indicators) {
    return Array.from(Array(pageCount).keys());
  }
  const left = Math.max(0, Math.min(pageCount - segmentCount, activePage - Math.floor(segmentCount / 2)));
  const items = new Array(segmentCount);
  for (let i = 0; i < segmentCount; i += 1) {
    items[i] = i + left;
  }

  // Left side of the array
  if (items[0] > 0) {
    items[0] = 0;
    // Add null to mark spill
    items[1] = null;
  }

  // Right side of the array
  if (items[items.length - 1] < pageCount - 1) {
    items[items.length - 1] = pageCount - 1;
    // Add null to mark spill
    items[items.length - 2] = null;
  }
  return items;
}